"use client";

import { memo } from "react";
import { Heading, type HeadingProps } from "@repo/ui/heading";
import {
  BlocksRenderer,
  type BlocksContent,
} from "@strapi/blocks-react-renderer";

export type PreIntroHeading = {
  id: number;
  title: string;
  level: HeadingProps["level"];
};

export interface PreIntroProps {
  heading: PreIntroHeading;
  description?: BlocksContent | null;
  className?: string;
}

export default function PreIntroBase({
  heading,
  description,
  className = "",
}: PreIntroProps) {
  return (
    <>
      <section
        className={`max-w-5xl mx-auto relative md:py-32 py-14 w-full px-6 ${className}`}
        aria-labelledby={`preintro-${heading.id}`}
        role="region"
      >
        <div className="flex flex-col xl:gap-10 md:gap-8 gap-6 max-w-4xl">
          <Heading
            id={`preintro-${heading.id}`}
            level={heading.level || "h1"}
            className="xl:text-6xl lg:text-5xl text-4xl tracking-tighter leading-tight font-noto max-w-4xl"
          >
            <span>{heading.title}</span>
          </Heading>

          {description && (
            <div className="pre-intro-content">
              <BlocksRenderer content={description!} />
            </div>
          )}
        </div>
      </section>
    </>
  );
}
